export type HomeLaunchpadEmptyStateId =
  | "noData"
  | "noCategoryResults"
  | "noSearchResults";

export interface IHomeLaunchpadEmptyStateMessage {
  labelKey: string;
  defaultLabel: string;
}

export const HOME_LAUNCHPAD_EMPTY_STATES: Record<
  HomeLaunchpadEmptyStateId,
  IHomeLaunchpadEmptyStateMessage
> = {
  noData: {
    labelKey: "hub.home.no_data",
    defaultLabel: "No applications available.",
  },
  noCategoryResults: {
    labelKey: "hub.home.no_category_results",
    defaultLabel: "No applications match the selected filter.",
  },
  noSearchResults: {
    labelKey: "hub.home.no_search_results",
    defaultLabel: "No applications or solutions match your search.",
  },
};
